import React, { useCallback, useMemo, useState } from "react";
import {
  Button,
  Form,
  Offcanvas,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import EventIcon from "../../assets/icons/Icon_Library/application icons/assets/events/asset_events/vehicle.svg2";
import CreatedByIcon from "../../assets/icons/Icon_Library/application icons/assets/events/created_by-01.svg2";
import CommunicationIcon from "../../assets/icons/Icon_Library/application icons/assets/events/one_off_comms-01.svg2";
import LogicIcon from "../../assets/icons/Icon_Library/application icons/assets/events/logic_project-01.svg2";
import AddIcon from "../../assets/icons/Icon_Library/application icons/assets/events/add_circle-01.svg2";
import TicketIcon from "../../assets/icons/Icon_Library/application icons/assets/events/ticket_details-01.svg2";
import EditIcon from "../../assets/icons/Icon_Library/application icons/assets/events/edit-01.svg2";
import MyIcon from "../Common/MyIcon";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import MyModal from "../Common/MyModal";
import AssetList from "../Assets/AssetList";
import MyTemplateCard from "../Library/MyTemplateCard";
import ComponentCard from "../Library/ComponentCard";
import { Label } from "recharts";
import { eventTypes } from "./EventType";
import MyCollapse from "../Common/MyCollapse";
import NewFeature from "../Builder/Components/NewFeature";
import EventAddTicketModal from "./EventAddTicketModal";
import EventUpdateModal from "./EventUpdateModal";
import EventCreateAnUpdateModal from "./EventCreateAnUpdateModal";
import EventCreateCommunicationModal from "./EventCreateCommunicationModal";
import EventCloseEventModal from "./EventCloseEventModal";
import EventsAssetsSlider from "./EventsAssetsSlider";
import Featues from "../Featues";
import EventTicketsSlider from "./EventTicketsSlider";
import { useGetReportingEntriesQuery } from "../store/slices/reportingSlice";
import ShowMore from "../Common/ShowMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faRectangleList,
  faRotateLeft,
  faSpinner,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";
import {
  useGetEventQuery,
  useGetLogsQuery,
} from "../store/slices/settingsSlice";
import { Link } from "react-router-dom";
import { solutionRolesMapping } from "../Library/SelectSolutionProject";
import ProjectStartForm from "../Builder/Components/sidebar/ProjectStartForm";
import MapAssetsSlider from "./MapAssetsSlider";
import EventsContactsSlider from "./EventsContactsSlider";
import EventAssetContacts from "./EventAssetContacts";
import EventsAssetContactsSlider from "./EventAssetContacts";
import LightBroadcast from "../Broadcast/LightBroadcast";
import EventContactsSlider from "./EventsContactsSlider";
import { faPagelines } from "@fortawesome/free-brands-svg-icons";
import Table from "../Reporting/RealtimeReporting/Table";

// export type EventType = {
//   Uuid: string;
//   ClientId: number;
//   Reference: string;
//   Label: string;
//   Description: string;
//   Ticket: string;
//   Status: "active" | "resolved" | "closed" | "archived";
//   Severity: "low" | "medium" | "high" | "critical";
//   StartAt: string; // ISO date string
//   EndAt: { Time: string; Valid: boolean }; // ISO date string or null
//   CreatedAt: string; // ISO date string
//   UpdatedAt: string; // ISO date string
//   EventAssets: { AssetUuid: string }[]; // Array of asset UUIDs
// };

const LogicPopover = (
  <Popover id="popover-logic">
    <Popover.Header as="h3">Popover right</Popover.Header>
    <Popover.Body>
      And here's some <strong>amazing</strong> content. It's very engaging.
      right?
    </Popover.Body>
  </Popover>
);

const CommunicationPopover = (
  <Popover id="popover-communication">
    <Popover.Header as="h3" className="bg-colored-reverse">
      <span className="text-white">Communications</span>
    </Popover.Header>
    <Popover.Body></Popover.Body>
  </Popover>
);

const ActionRequiredPopover = (
  <Popover id="popover-action-required">
    <Popover.Header as="h3" className="bg-colored-reverse">
      <span className="text-white">Action Required</span>
    </Popover.Header>
    <Popover.Body>
      <div className="my-2">
        <div className="me-2 d-flex justify-content-between align-items-center">
          <div className="fw-bold ">Last Seen</div>
          <div className="fw-bold text-navy fs-4">21:30</div>
        </div>
        <hr className="m-0" />
        <div className="me-2 d-flex justify-content-between align-items-center">
          <div className="fw-bold ">Next sent request:</div>
          <div className="fw-bold text-navy fs-4">1 hr</div>
        </div>
        <hr className="m-0" />
        <div className="me-2 d-flex justify-content-between align-items-center">
          <div className="fw-bold ">Weather event update</div>
          <div className="fw-bold text-navy fs-4">20</div>
        </div>
        <hr className="m-0" />
        <div className="me-2 d-flex justify-content-between align-items-center">
          <div className="fw-bold ">Other</div>
          <div className="fw-bold text-navy fs-4">50</div>
        </div>
        <hr className="m-0" />
      </div>
    </Popover.Body>
  </Popover>
);
function EventsTimeLine({ eventUuid, label, hideAllMessages = false }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const eventRes = useGetEventQuery(eventUuid, { skip: !show });
  const eventData = eventRes?.data || {};
  const isEventNoSolution = !eventData?.SolutionClientUuid;
  const eventSolution = eventData?.SolutionClient || {};
  const refetchEvent = eventRes?.refetch;

  const features = eventSolution?.Features || [];
  const createUpdateFeature = useMemo(
    () => features.find((f) => f.Feature === "create-update"),
    [features]
  );
  const hasCreateCommunication = useMemo(
    () =>
      features.some(
        (f) => f.Feature === "create-communication" && f.Status === "enabled"
      ),
    [features]
  );
  const hasAddTicket = useMemo(
    () =>
      features.some(
        (f) => f.Feature === "add-ticket" && f.Status === "enabled"
      ),
    [features]
  );
  const hasCreateUpdate = useMemo(
    () =>
      features.some(
        (f) => f.Feature === "create-update" && f.Status === "enabled"
      ),
    [features]
  );
  const contextProjects = useMemo(
    () => features.filter((f) => f.Feature === "context-project"),
    [features]
  );
  const createUpdateFieldSet = useMemo(
    () => new Set(createUpdateFeature?.Fields || []),
    [createUpdateFeature?.Fields]
  );
  const allMessagesFilters = useCallback(
    ({ brUUID } = {}) => ({
      startDate: new Date(
        new Date(eventData.CreatedAt).getTime() - 24 * 60 * 60 * 1000
      ),
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
      billing: null,
      showWhen: "received",
      comms: ["sms", "email", "voice"],
      messageDirection: ["1-Way", "2-Way"],
      messageStatus: [
        "delivered",
        "sent",
        "expired",
        "failed",
        "pending",
        "cancelled",
        "unknown",
      ],
      recipientQueryString: "",
      timeUnit: "day",
      customers: [],
      accounts: [],
      unit: "transactions",
      projectUUID: null,
      broadcastUUID: brUUID || null,
      inboundUUID: null,
      eventUUID: brUUID ? null : eventUuid,
    }),
    [eventData.StartAt, eventUuid]
  );

  const [reportingPagination, setReportingPagination] = useState({
    page: 0,
    perPage: 10,
  });
  const updates = useGetReportingEntriesQuery(
    {
      filters: {
        templateUuids: createUpdateFeature?.Templates,
        topics: createUpdateFeature?.Topics,

        // // not working
        values: [
          {
            or: false,
            fields: [createUpdateFeature?.RefField],
            operator: "is",
            values: [eventData.Reference],
          },
        ],

        // contactUuids: [],
        // tickets: [],
        // search: "",
        // dateGte: null,
        // dateLte: null,
      },
      pagination: reportingPagination,
    },
    { skip: !show || !eventData.Reference || !createUpdateFeature?.RefField }
  );

  const [logsPagination, setLogsPagination] = useState({
    offset: 0,
    limit: 10,
  });
  const logsRes = useGetLogsQuery(
    { kind: "event", resource: eventUuid, ...logsPagination },
    { skip: !show }
  );

  const logsData = logsRes?.data || { logs: [], total: 0 };

  const [collapsed, setCollapsed] = useState(true);
  return (
    <>
      <Button
        variant=""
        onClick={handleShow}
        className="btn btn-link fw-bold p-0 bg-transparent"
      >
        {label}
      </Button>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="bg-page p-4 z-4000"
        backdropClassName="z-3999"
        size="xl"
      >
        <AbsoluteLoadingIndicator loading={eventRes.isFetching} />
        <div
          className="overflow-x-hidden position-relative pe-3"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="d-flex justify-content-between align-items-center mb-1
          "
          >
            <div className="">
              <div className="fw-bold"> Start:</div>
              <div className=" fw-bold text-secondary ">
                {new Date(eventData.StartAt).toLocaleString()}
              </div>
            </div>
            {eventData.Status === "active" ? (
              <div className="">
                <div className="fw-bold text-nowrap"> Running time:</div>
                <div>
                  <div className=" fw-bold text-secondary">
                    {(() => {
                      const now = new Date();
                      const createdDate = new Date(eventData.StartAt);
                      const diffMs = now - createdDate;

                      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                      const hours = Math.floor(
                        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                      );
                      const minutes = Math.floor(
                        (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                      );

                      return (
                        <>
                          <span className="mx-1">
                            <span className="text-navy fw-bold">{days}</span>
                            <span className="fw-bold">days</span>
                          </span>
                          <span className="fw-bold">:</span>
                          <span className="mx-1">
                            <span className="text-navy fw-bold">{hours}</span>
                            <span className="fw-bold">hrs</span>
                          </span>
                          <span className="fw-bold">:</span>
                          <span className="mx-1">
                            <span className="text-navy fw-bold">{minutes}</span>
                            <span className="fw-bold">mins</span>
                          </span>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ) : (
              <div className="">
                <div className="fw-bold"> Closed:</div>
                <div className=" fw-bold text-secondary ">
                  {new Date(eventData.EndAt?.Time).toLocaleString()}
                </div>
              </div>
            )}
          </div>
          <div>
            <div className="text-center p-1 align-items-center mb-2 bg-colored-reverse rounded-pill px-5 fw-bold text-white">
              EVENTS & ALERTS{" "}
              <span
                className={`badge rounded-pill ${
                  eventData.Status === "active"
                    ? "bg-danger"
                    : eventData.Status === "closed"
                    ? "bg-secondary"
                    : eventData.Status === "resolved"
                    ? "bg-success"
                    : eventData.Status === "creating"
                    ? "bg-warning"
                    : ""
                }`}
              >
                {eventData.Status}
                {eventData.Status === "creating" ? (
                  <FontAwesomeIcon
                    size="sm"
                    className="ms-2"
                    icon={faSpinner}
                    spin
                  />
                ) : null}
              </span>
              <button
                className="btn p-0 ms-2 text-white"
                onClick={refetchEvent}
              >
                <FontAwesomeIcon
                  icon={faSync}
                  spin={eventRes.isFetching || eventRes.isLoading}
                />
              </button>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className=" fw-bold">Event name:</div>
              <div className="fw-bold text-navy">{eventData.Label}</div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className=" fw-bold">Event type:</div>
              <div className="fw-bold text-navy">{eventTypes[0].label}</div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="fw-bold">Severity:</div>
              <div className="fw-bold ">
                <span
                  className="badge rounded-pill"
                  style={{
                    backgroundColor:
                      eventData.Severity === "critical"
                        ? "red"
                        : eventData.Severity === "high"
                        ? "orange"
                        : eventData.Severity === "medium"
                        ? "gold"
                        : "seagreen",
                  }}
                >
                  {eventData.Severity}
                </span>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div className=" fw-bold">Ref:</div>
              <div className="fw-bold text-navy">{eventData.Reference}</div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className=" fw-bold">Customer Ref:</div>
              <div className="fw-bold text-navy">B00M-456</div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div className="fw-bold ">
                Assets impacted:
                <span className="text-white badge bg-secondary fw-bold ms-1">
                  {" "}
                  {eventData.AssetsCount ?? "N/A"}
                </span>
              </div>
              <div className="d-flex gap-2">
                <div className="">
                  <EventsAssetsSlider
                    item={eventData}
                    eventSolution={eventSolution}
                  />
                </div>
                <div>
                  <MapAssetsSlider
                    item={eventData}
                    eventSolution={eventSolution}
                  />
                </div>
                <div>
                  <EventsAssetContactsSlider item={eventData} />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="fw-bold ">Contacts impacted:</div>
              <div className="d-flex gap-2">
                <div className="">
                  <EventContactsSlider
                    event={eventData}
                    eventSolution={eventSolution}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div className="fw-bold ">
                Event locations:
                <span className="text-white badge bg-secondary fw-bold ms-1"></span>
              </div>
              <div className="d-flex gap-2">
                <div>
                  <MapAssetsSlider
                    item={eventData}
                    eventSolution={eventSolution}
                    isEventLocations
                  />
                </div>
              </div>
            </div>

            {eventData.Status === "active" && (
              <>
                <hr className="text-secondary " />
                <div className="d-flex justify-content-between mt-2 gap-1">
                  <div>
                    {hasCreateCommunication ? (
                      <EventCreateCommunicationModal
                        eventData={eventData}
                        eventSolution={eventSolution}
                      />
                    ) : (
                      <MyModal
                        label="Create Communication"
                        buttonClassName="bg-colored-reverse px-3 btn-sm rounded-pill border-0 fw-bold text-nowrap text-white p-1"
                        heading="Message"
                        size="lg"
                      >
                        <LightBroadcast
                          // showRecipientsSelection={false}
                          showAssetSelection={false}
                          events={[eventData.Uuid]}
                          showRecipients={false}
                          showEventRecipients
                          showSendTestButton
                        />
                      </MyModal>
                    )}
                  </div>
                  {!hideAllMessages && (
                    <div>
                      <MyModal
                        label={"Show all Messages"}
                        buttonClassName="bg-colored-reverse px-3 btn-sm rounded-pill border-0 fw-bold text-nowrap text-white p-1"
                        heading="Communications history"
                        size="xl"
                      >
                        <div style={{ minHeight: 400 }}>
                          <Table
                            filters={allMessagesFilters()}
                            setLoading={() => {}}
                            loading={false}
                          />
                        </div>
                      </MyModal>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {!isEventNoSolution && (
            // TICKETS SECTION
            <>
              <hr className="text-secondary " />
              <div className="align-items-start d-flex justify-content-between  mb-2">
                <div>
                  <TicketIcon width={25} className="me-1" />
                  <span className="fw-bold">Tickets:</span>
                </div>
                <div className="">
                  <EventTicketsSlider item={eventData} />
                  {eventData.Status === "active" && hasAddTicket ? (
                    <div className="d-flex justify-content-end ">
                      <EventAddTicketModal
                        eventData={eventData}
                        eventSolution={eventSolution}
                      />
                    </div>
                  ) : (
                    eventData.TicketsCount === 0 && "No tickets."
                  )}
                </div>
              </div>
            </>
          )}

          {!isEventNoSolution && (
            // PROCESSES SECTION
            <>
              <hr className="text-secondary m-0" />
              <div className=" ">
                <div className="fw-bold my-2">Progress:</div>
                <div className="my-2">
                  <div className="me-2 d-flex justify-content-between align-items-center">
                    <div className="fw-bold text-navy fs-4">
                      {eventData.ProcessesRunningCount}
                    </div>
                    <div className="fw-bold "> Running Processes</div>
                  </div>
                  <hr className="m-0" />
                  <div className="me-2 d-flex justify-content-between align-items-center">
                    <div className="fw-bold text-navy fs-4">
                      {eventData.ProcessesTotalCount}
                    </div>
                    <div className="fw-bold ">Total Processes</div>
                  </div>
                  <hr className="m-0" />
                  <div className="me-2 d-flex justify-content-between align-items-center">
                    <div className="fw-bold text-navy fs-4">
                      {updates.data?.info.total || 0}
                    </div>
                    <div className="fw-bold ">User updates</div>
                  </div>{" "}
                  <hr className="m-0" />
                  <div className="d-flex justify-content-between align-items-center my-2">
                    <div className="fw-bold  ">Time since last activity</div>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {(() => {
                        const now = new Date();
                        const createdDate = updates.data?.data[0]?.createdAt
                          ? new Date(updates.data.data[0].createdAt)
                          : new Date(eventData.CreatedAt);
                        const diffMs = now - createdDate;

                        const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                        const hours = Math.floor(
                          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                        );
                        const minutes = Math.floor(
                          (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                        );

                        if (days === 0 && hours === 0 && minutes === 0) {
                          return (
                            <span className="fw-bold text-navy">Just now</span>
                          );
                        }

                        return (
                          <>
                            <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                              <div className="text-navy fw-bold">{days}</div>
                              <div className="fw-bold">days</div>
                            </span>
                            <span className="fw-bold">:</span>
                            <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                              <div className="text-navy fw-bold">{hours}</div>
                              <div className="fw-bold">hrs</div>
                            </span>
                            <span className="fw-bold">:</span>
                            <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                              <div className="text-navy fw-bold">{minutes}</div>
                              <div className="fw-bold">mins</div>
                            </span>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {
            // LOGS (Timeline) SECTION
            <>
              <hr className="text-secondary my-3" />
              <div className="position-relative">
                <AbsoluteLoadingIndicator loading={logsRes.isFetching} />
                <div className="rounded-2">
                  {logsData?.total > 0 ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="fw-bold my-2">Event timeline:</div>
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn"
                            onClick={() => logsRes.refetch()}
                          >
                            <FontAwesomeIcon
                              icon={faRotateLeft}
                              spin={logsRes.isFetching}
                            />
                          </button>
                        </div>
                      </div>

                      {logsData.logs.map((update, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>
                          <div className="d-flex justify-content-between overflow-auto row my-2 align-items-start mb-3">
                            <div className="col-4">
                              <div className="bg-colored-reverse text-center rounded-2 fw-bold h-50 text-white p-2">
                                {update.CreatedAt && (
                                  <div>
                                    <div>
                                      {new Date(
                                        update.CreatedAt
                                      ).toLocaleDateString()}
                                    </div>
                                    <div>
                                      {new Date(update.CreatedAt)
                                        .toLocaleTimeString({
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                        .replace(/(.*)\D\d+/, "$1")}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col">
                              <div>{update.Message}</div>
                              <div className="text-muted"> {update.User}</div>
                            </div>
                            <div className="col-auto">
                              <MyModal
                                label={
                                  <FontAwesomeIcon icon={faRectangleList} />
                                }
                                buttonClassName="p-0"
                                heading="Log details"
                              >
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Field</th>
                                      <th>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Created At</td>
                                      <td>
                                        {new Date(
                                          update.CreatedAt
                                        ).toLocaleString()}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Level</td>
                                      <td>{update.Level}</td>
                                    </tr>

                                    <tr>
                                      <td>Message</td>
                                      <td>{update.Message}</td>
                                    </tr>
                                    <tr>
                                      <td>User</td>
                                      <td>{update.User}</td>
                                    </tr>
                                    <tr>
                                      <td>RequestId</td>
                                      <td>{update.RequestId || "-"}</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {update.Message ===
                                        "event-notification-sent"
                                          ? ""
                                          : "Data"}
                                      </td>
                                      <td>
                                        {update.Message ===
                                        "event-notification-sent" ? (
                                          <MyModal
                                            label={"Show messages"}
                                            buttonClassName="bg-colored-reverse px-3 btn-sm rounded-pill border-0 fw-bold text-nowrap text-white p-1"
                                            heading="Communications history"
                                            size="xl"
                                          >
                                            <div style={{ minHeight: 400 }}>
                                              <Table
                                                filters={allMessagesFilters({
                                                  brUUID: update.Data.broadcast,
                                                })}
                                                setLoading={() => {}}
                                                loading={false}
                                              />
                                            </div>
                                          </MyModal>
                                        ) : (
                                          <pre className="bg-light p-2 rounded">
                                            {JSON.stringify(
                                              update.Data,
                                              null,
                                              2
                                            )}
                                          </pre>
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </MyModal>
                            </div>
                          </div>
                        </div>
                      ))}
                      {logsData.total > 10 && (
                        <div className="d-flex my-3 justify-content-between align-items-center">
                          <button
                            type="button"
                            className="bg-colored-reverse rounded-pill text-white px-3 fw-bold btn-sm border-0"
                            onClick={() =>
                              setLogsPagination((prev) => ({
                                ...prev,
                                offset: Math.max(prev.offset - prev.limit, 0),
                              }))
                            }
                            disabled={logsPagination.offset === 0}
                          >
                            Previous
                          </button>
                          <div>
                            showing{" "}
                            {Math.min(
                              logsPagination.offset + logsPagination.limit,
                              logsData.total
                            )}{" "}
                            of {logsData.total} entries
                          </div>
                          <button
                            type="button"
                            className="bg-colored-reverse rounded-pill text-white fw-bold btn-sm px-3 border-0"
                            onClick={() =>
                              setLogsPagination((prev) => ({
                                ...prev,
                                offset: prev.offset + prev.limit,
                              }))
                            }
                            disabled={
                              logsPagination.offset + logsPagination.limit >=
                              logsData.total
                            }
                          >
                            Next
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="d-flex flex-column gap-2 align-items-center">
                      <div className="justify-content-center">
                        <span>No Logs available</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          }

          {!isEventNoSolution && (
            // CUSTOMER UPDATES SECTION
            <>
              <hr className="text-secondary my-3" />
              <div className="position-relative">
                <AbsoluteLoadingIndicator loading={updates.isFetching} />
                <div className="rounded-2">
                  {updates.data?.info.total > 0 ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="fw-bold my-2">Customer Updates:</div>
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn"
                            onClick={() => updates.refetch()}
                          >
                            <FontAwesomeIcon
                              icon={faRotateLeft}
                              spin={updates.isFetching}
                            />
                          </button>
                        </div>
                      </div>

                      {updates.data.data.map((update, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>
                          <div className="d-flex justify-content-between overflow-auto row my-2 align-items-start mb-3">
                            <div className="col-4">
                              <div className="bg-colored-reverse text-center rounded-2 fw-bold h-50 text-white p-2">
                                {update.createdAt &&
                                  new Date(update.createdAt)
                                    .toLocaleString({
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                    .replace(/(.*)\D\d+/, "$1")}
                              </div>
                            </div>

                            <div className="col">
                              {update.values
                                .filter((v) =>
                                  createUpdateFieldSet.has(v.field.uuid)
                                )
                                .map((value) => (
                                  <div key={value.field.uuid}>
                                    <ShowMore text={value.data} limit={30} />
                                    <hr className="text-secondary mb-2" />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      ))}
                      {updates.data?.info.total > 10 && (
                        <div className="d-flex my-3 justify-content-between align-items-center">
                          <button
                            type="button"
                            className="bg-colored-reverse rounded-pill text-white px-3 fw-bold btn-sm border-0"
                            onClick={() =>
                              setReportingPagination((prev) => ({
                                ...prev,
                                page: Math.max(prev.page - 1, 0),
                              }))
                            }
                            disabled={reportingPagination.page === 0}
                          >
                            Previous
                          </button>
                          <div>
                            showing{" "}
                            {Math.min(
                              (reportingPagination.page + 1) *
                                reportingPagination.perPage,
                              updates.data?.info.total
                            )}{" "}
                            of {updates.data?.info.total} entries
                          </div>
                          <button
                            type="button"
                            className="bg-colored-reverse rounded-pill text-white fw-bold btn-sm px-3 border-0"
                            onClick={() =>
                              setReportingPagination((prev) => ({
                                ...prev,
                                page: prev.page + 1,
                              }))
                            }
                            disabled={
                              (reportingPagination.page + 1) *
                                reportingPagination.perPage >=
                              updates.data?.info.total
                            }
                          >
                            Next
                          </button>
                        </div>
                      )}

                      {eventData.Status === "active" && hasCreateUpdate ? (
                        <div>
                          <EventCreateAnUpdateModal
                            eventData={eventData}
                            eventSolution={eventSolution}
                          />
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <div className="d-flex flex-column gap-2 align-items-center">
                      <div className="justify-content-center">
                        <span>No customer updates available</span>
                        {createUpdateFeature?.RefField ? (
                          <span className="">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => updates.refetch()}
                            >
                              <FontAwesomeIcon
                                icon={faSync}
                                spin={updates.isFetching}
                              />
                            </button>
                          </span>
                        ) : null}
                      </div>

                      <AbsoluteLoadingIndicator loading={updates.isFetching} />

                      {eventData.Status === "active" ? (
                        <div className="justify-content-center">
                          <EventCreateAnUpdateModal
                            eventData={eventData}
                            eventSolution={eventSolution}
                          />
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          <hr className="text-secondary my-3" />
          <div>
            <div className="fw-bold my-2"> Activation conditions:</div>
            <div className="bg-icon p-3 rounded-3 mb-3">
              <div className="">
                <div className="fw-bold mt-1">Description of event</div>
                <div className="text-secondary my-2 ">
                  {eventData.Description}
                </div>
                <div className="d-flex align-items-center justify-content-between my-2">
                  <div className="align-items-center mt-1 mb-2">
                    <span>
                      <CreatedByIcon width={15} className="me-1" />
                    </span>
                    <span className="fw-bold fs-6">Activated by:</span>
                  </div>
                  <div>
                    <a href="/about">
                      <span type="button" className="fw-bold text-navy">
                        {eventData.Email}
                      </span>
                    </a>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2">
                  <div className=" fw-bold">How activated: </div>
                  <div className="fw-bold text-navy">
                    {eventData.CreatedMethod === "user"
                      ? "User via UI"
                      : eventData.CreatedMethod}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2">
              {eventData.Status === "active" ? (
                <EventUpdateModal
                  eventData={eventData}
                  eventSolution={eventSolution}
                />
              ) : null}
              {eventData.Status === "active" ? (
                <EventCloseEventModal
                  eventData={eventData}
                  eventSolution={eventSolution}
                />
              ) : null}
            </div>
          </div>

          {!isEventNoSolution && (
            // LOGIC SERVICE SECTION
            <>
              <hr />
              <div className=" my-3">
                <div className="">
                  <div className="fw-bold ">Logic Service Selected</div>
                  <div className="text-secondary">
                    This event is connected with this component{" "}
                  </div>
                </div>

                {eventData.Project ? (
                  <Link
                    to={`/library/logic/builder/${eventData.Project?.ID}`}
                    target="_blank"
                  >
                    <MyTemplateCard isSelected>
                      <ComponentCard project={eventData.Project} />
                    </MyTemplateCard>
                  </Link>
                ) : (
                  <div className="my-3 fw-bold">Project not found.</div>
                )}
              </div>
            </>
          )}

          {!isEventNoSolution && (
            // Projects section
            <>
              <hr />
              <div className="my-3">
                <div className="fw-bold my-2">
                  Projects related to this event:
                </div>
                {contextProjects.length > 0
                  ? contextProjects.map((feature) => (
                      <div className="bg-icon p-3 rounded-3 mb-3">
                        <div className="">
                          <div className="my-2 fw-bold">{feature.Label}</div>
                          <div className="text-secondary my-2 ">
                            {feature.ComponentDescription}
                          </div>
                          <div>
                            <MyModal
                              heading={`Start Project: ${feature.Label}`}
                              label="Run"
                              buttonClassName="btn btn-colored px-3 rounded-pill fw-bold text-white"
                              size="lg"
                            >
                              <ProjectStartForm
                                showHiddenVariables
                                projectID={feature.ID}
                                fixedRoleValues={{
                                  id: eventData.Reference,
                                }}
                              />
                            </MyModal>
                          </div>
                        </div>
                      </div>
                    ))
                  : "No related projects."}
              </div>
            </>
          )}
        </div>
      </Offcanvas>
    </>
  );
}

export default EventsTimeLine;
